import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function myInstalledJobsReducer(state = initialState.myInstalledJobs, action) {
  switch (action.type) {
    case types.LOAD_MY_INSTALLED_JOBS_SUCCESS:
      return action.myInstalledJobs;

    default:
      return state;
  }
}
